export const TRANSLATIONS_EN_PLANS_AND_ADMIN = {
  "usage.title": "My plan and usage",
  "usage.subtitle": "Review your current plan, limits and recent activity.",
  "usage.plan": "Plan",
  "usage.plan_unknown": "Plan unavailable",
  "usage.unlimited": "Unlimited",
  "usage.over_limit_blocking": "Limit reached",
  "usage.over_limit_allowed": "Over limit (allowed)",
  "usage.error.forbidden": "You do not have permission to view this account's usage.",
  "usage.error.generic": "We could not load your plan usage.",
  "usage.error.retry": "Retry",
  "usage.status.active": "Active",
  "usage.status.trialing": "Trial",
  "usage.status.cancelled": "Cancelled",
  "usage.status.expired": "Expired",
  "usage.status.suspended": "Suspended",
  "usage.enforcement.hard": "Strict",
  "usage.enforcement.soft": "Flexible",
  "usage.enforcement.dry_run": "Monitor only",
  "usage.unit.count": "requests",
  "usage.unit.tokens": "tokens",
  "usage.unit.pages": "pages",
  "usage.unit.bytes": "bytes",
  "usage.unit.monthly_chat_queries": "queries",
  "usage.unit.monthly_csv_queries": "queries",
  "usage.unit.monthly_documents_uploaded": "documents",
  "usage.unit.users_per_account": "users",
  "usage.unit.monthly_ocr_pages": "pages",
  "usage.freshness.no_snapshot": "No snapshot available",
  "usage.freshness.stale": "Data is stale",
  "usage.freshness.updating": "Updating data",
  "usage.freshness.fresh": "Up to date",
  "usage.flag.missing_subscription": "No subscription",
  "usage.flag.usage_not_evaluated": "Not evaluated",
  "usage.flag.missing_model_policy": "Missing model policy",
  "usage.flag.source_unavailable": "Source unavailable",
  "usage.flag.source_error": "Temporary error",
  "usage.flag.snapshot_stale": "Stale snapshot",
  "usage.flag.legacy": "Historical data",
  "usage.limit.monthly_chat_queries": "Monthly chat queries",
  "usage.limit.monthly_llm_tokens": "Monthly LLM tokens",
  "usage.limit.monthly_documents_uploaded": "Monthly documents uploaded",
  "usage.limit.monthly_csv_queries": "Monthly CSV queries",
  "usage.limit.monthly_ocr_pages": "Monthly OCR pages",
  "usage.limit.users_per_account": "Active users per account",
  "usage.limit.storage_bytes": "Storage",
  "usage.decisions.title": "Recent decisions",
  "usage.decisions.empty": "No decisions recorded yet.",
  "usage.decisions.allowed": "Allowed",
  "usage.decisions.blocked": "Blocked",
  "usage.decisions.pager": "Decisions pagination",
  "usage.decisions.col.timestamp": "Date",
  "usage.decisions.col.module": "Module",
  "usage.decisions.col.operation": "Operation",
  "usage.decisions.col.limit": "Limit",
  "usage.decisions.col.decision": "Decision",
  "usage.trial.banner": "Your trial ends in {{days}} days. Switch to a plan to keep your access.",
  "usage.trial.banner_one": "Your trial ends in {{days}} day. Switch to a plan to keep your access.",
  "usage.trial.cta": "View plans",
  "usage.consumed": "Consumed",
  "usage.limit_value": "Limit",
  "usage.period.month": "this month",
  "usage.hero.title": "Key usage this period",
  "usage.hero.used": "used",
  "usage.hero.no_data": "No data yet",
  "enforcement.banner.title": "Plan limit reached",
  "enforcement.banner.body": "You have reached the configured limit for your plan.",
  "enforcement.banner.cta": "View my plan",
  "payments.upgrade.title": "Change your plan",
  "payments.upgrade.subtitle": "Select an available plan and pay with Wompi Sandbox. We will confirm the change against backend.",
  "payments.upgrade.select_plan": "Target plan",
  "payments.upgrade.no_options": "There are no plans available to change from this account.",
  "payments.change_plan": "Change plan",
  "payments.contact_sales": "Contact sales",
  "payments.confirm.title": "Confirm payment",
  "payments.confirm.body": "You are creating an order for",
  "payments.confirm.pay": "Create order and pay",
  "payments.creating_order": "Creating order...",
  "payments.status.idle": "No active payment",
  "payments.status.checking_pending": "Checking pending order",
  "payments.status.creating_order": "Creating order",
  "payments.status.widget_open": "Payment form opened",
  "payments.status.pending_confirmation": "We are confirming your payment.",
  "payments.status.approved": "Payment approved. Your plan was updated.",
  "payments.status.declined": "Payment declined",
  "payments.status.voided": "The transaction was voided.",
  "payments.status.expired": "Order expired",
  "payments.status.error": "Payment could not be validated",
  "payments.error.invalid_request": "We could not create the order. Check the plan and price.",
  "payments.error.session": "Your session expired. Sign in again.",
  "payments.error.forbidden": "You cannot change the plan for this account.",
  "payments.error.unconfigured": "Wompi is not configured in backend.",
  "payments.error.generic": "We could not start the payment.",
  "payments.reference": "Reference",
  "payments.result.title": "Payment result",
  "payments.result.subtitle": "The redirect does not approve the payment. We validate status against backend.",
  "payments.result.back_to_usage": "Back to My plan",
  "payments.eligible": "Eligible",
  "payments.ineligible.no_price": "No price",
  "payments.ineligible.inactive": "Inactive price",
  "payments.ineligible.custom": "Custom price",
  "payments.ineligible.currency": "COP only",
  "payments.ineligible.amount": "Invalid amount",
  "plans.admin.title": "Plans",
  "plans.admin.subtitle": "Plan catalog and components.",
  "plans.admin.include_inactive": "Include inactive",
  "plans.admin.back": "Back to plans",
  "plans.admin.tab.plans": "Plans",
  "plans.admin.tab.over_limit": "Over limit",
  "plans.admin.tab.llm_usage": "LLM usage",
  "plans.code": "Code",
  "plans.name": "Name",
  "plans.description": "Description",
  "plans.active": "Active",
  "plans.inactive": "Inactive",
  "plans.enabled": "Enabled",
  "plans.saved": "Changes saved.",
  "plans.sort_order": "Sort order",
  "plans.tab.general": "General",
  "plans.tab.features": "Features",
  "plans.tab.limits": "Limits",
  "plans.tab.prices": "Prices",
  "plans.tab.models": "Model policies",
  "plans.unlimited": "Unlimited",
  "plans.currency": "Currency",
  "plans.amount": "Amount",
  "plans.period": "Period",
  "plans.sandbox_account_id": "Sandbox accountId",
  "plans.sandbox_payment": "Test sandbox",
  "plans.sandbox_missing_account": "Enter a valid sandbox accountId.",
  "plans.sandbox_started": "Sandbox flow started.",
  "plans.sandbox_error": "Sandbox flow could not be started.",
  "plans.default_model": "Default model",
  "plans.account": "Account",
  "plans.change_plan": "Change plan",
  "plans.subscriptions.title": "Subscriptions",
  "plans.subscriptions.subtitle": "Manual plan and status support. This does not replace the Wompi commercial flow.",
  "plans.subscriptions.active": "Active subscription",
  "plans.subscriptions.create": "Create subscription",
  "plans.subscriptions.saved": "Subscription updated.",
  "plans.subscriptions.open": "Open subscriptions",
  "plans.over_limit.title": "Over-limit accounts",
  "plans.over_limit.subtitle": "Accounts with exceeded limits according to the operational snapshot.",
  "plans.over_limit.empty": "No accounts over limit.",
  "llm_usage.title": "LLM usage",
  "llm_usage.subtitle": "Real LLM tokens without costs or embeddings.",
  "llm_usage.records": "Records",
  "llm_usage.query_records": "Queries",
  "llm_usage.document_records": "Documents",
  "llm_usage.total_tokens": "Total tokens",
  "admin.title": "Administration",
  "admin.members": "Members",
  "admin.invite": "Invite",
  "admin.pending": "Pending Invites",
  "admin.roles": "Roles",
  "admin.experts": "Experts",
  "admin.experts.title": "Account experts",
  "admin.experts.subtitle": "Enable the experts your account will use, like plugins. Only enabled ones show up in chat. Each expert's configuration is system-defined.",
  "admin.experts.enabledCount": "enabled",
  "admin.experts.loading": "Loading experts…",
  "admin.experts.loadError": "Could not load experts.",
  "admin.experts.saveError": "Could not update the expert.",
  "admin.experts.enabled": "On",
  "admin.experts.disabled": "Off",
  "admin.experts.enable": "Enable",
  "admin.experts.disable": "Disable",
  "admin.experts.tooltipTitle": "How it enriches your query",
  "admin.experts.customBadge": "Custom",
  "admin.experts.create": "Create expert",
  "admin.experts.createTitle": "New expert",
  "admin.experts.createSubtitle": "This expert will be private to your account. Tell us how it should respond; we build the rest.",
  "admin.experts.fieldName": "Name",
  "admin.experts.fieldNamePlaceholder": "e.g. Contracts expert",
  "admin.experts.fieldDescription": "Short description (optional)",
  "admin.experts.fieldDescriptionPlaceholder": "e.g. Reviews contracts and flags risks",
  "admin.experts.fieldIcon": "Icon",
  "admin.experts.fieldInstruction": "How should it respond?",
  "admin.experts.fieldInstructionPlaceholder": "e.g. Act as a contracts lawyer: identify key clauses, obligations and risks, and suggest what to review. Be clear and prudent.",
  "admin.experts.instructionHint": "Write it in plain language. We turn it into the expert's behavior.",
  "admin.experts.createSubmit": "Create",
  "admin.experts.creating": "Creating…",
  "admin.experts.createError": "Could not create the expert.",
  "admin.experts.cancel": "Cancel",
  "admin.experts.delete": "Delete",
  "admin.experts.deleteConfirm": "Delete the expert",
  "admin.experts.deleteError": "Could not delete the expert.",
  "admin.settings.title": "Administration",
  "admin.settings.organizationName": "Organization name",
  "admin.settings.inviteExpiryDays": "Invitation expiry days (1-60)",
  "admin.settings.allowedDomains": "Allowed domains (comma or line separated)",
  "admin.settings.defaultRole": "Default role",
  "admin.settings.locale": "Locale",
  "admin.members.title": "Organization members",
  "admin.invite.title": "Invite user",
  "admin.invite.send": "Send invitation",
  "admin.invite.invitations": "Invitations",
  "admin.invite.resend": "Resend invitation",
  "admin.invite.revoke": "Revoke invitation",
  "admin.invite.empty": "No invitations to display.",
  "admin.roles.title": "Roles and permissions",
  "admin.roles.permissions": "Permissions",
  "admin.roles.delete": "Delete role",
};
